import _isCallable from "../internals/is-callable";
import _documentAll from "../internals/document-all";
var exports = {};
var isCallable = _isCallable;
var $documentAll = _documentAll;
var documentAll = $documentAll.all;
exports = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == "object" ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == "object" ? it !== null : isCallable(it);
};
export default exports;